export interface TipoDocumentoDto {
  codigo: number;
  descricao: string;
  nomeAbreviado: string
}

export enum TipoDocumentoEnum {
  DJE = 7,
  DAS = 9,
  // DARF => Diferente de 7 e 9
}